
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career-advice",
      function () {
        return require("private-next-pages/career-advice/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career-advice"])
      });
    }
  